// extracted by mini-css-extract-plugin
export default {"tableWrapper":"SearchResultsTable-module__tableWrapper__qO5Lw"};